import theme from 'core/theme/theme.config';
import horiLogo from '../../assets/images/horiLogo.png';
import veriLogo from '../../assets/images/vertiLogo.jpeg';
import enflag from '../../assets/images/flags/en.svg';
import deflag from '../../assets/images/flags/de.svg';
import esflag from '../../assets/images/flags/es.svg';
import hiflag from '../../assets/images/flags/hi.svg';
// import AugmentLogo from '../../assets/images/paypromptLogo.svg';
// import AugmentLogoSmall from '../../assets/images/paypromptLogoSmall.svg';
import PaypromtLogo from '../../assets/images/augmentNewLogo.png';
import leftArrow from '../../assets/images/leftArrow.png';
import rightArrow from '../../assets/images/rightArrow.png';
import fileUploadIcon from '../../assets/images/fileUploadIcon.png';
// import loaderGif from '../../assets/gifs/loader.gif';

const brandAsset = (file) => {
  // eslint-disable-next-line global-require, import/no-dynamic-require, @typescript-eslint/no-var-requires
  const mod = require(`../../assets/${file}`);
  return mod.default || mod;
};
const AugmentLogo = brandAsset(theme.brand.logo);
const AugmentLogoSmall = brandAsset(theme.brand.logoCollapsed);
const loaderGif = brandAsset(theme.brand.loader);

export default function imageFlag(type) {
  let flag;
  switch (type) {
    case 'de':
      flag = deflag;
      break;
    case 'es':
      flag = esflag;
      break;
    case 'hi':
      flag = hiflag;
      break;
    default:
      flag = enflag;
  }

  return flag;
}

export const Images = {
  horiLogo,
  veriLogo,
  AugmentLogo,
  AugmentLogoSmall,
  PaypromtLogo,
  leftArrow,
  rightArrow,
  fileUploadIcon,
  loaderGif,
};
